import Button from "../../global/Buttons/Button";
import TextField from "../../global/Inputs/TextField";
import Link from "next/link";
import { UserRow } from "../Subscription/UserRow";
import { useGiftActions } from "../../../hooks/useGiftActions";
import { Fragment } from "react";
import { TextArea } from "../../global/Inputs/TextArea";
import { backText } from "../../../utils/user";
import { useAuth } from "../../../context/authContext";

export const Gift = () => {
  const {
    giftSubscription,
    handleOnChange,
    handleEnter,
    submitInfo,
    isLoading,
    isDisabled,
    handleAddRecipient,
    handleOnRecipientChange,
  } = useGiftActions();

  const { state: { user } } = useAuth();

  return (
    <div
      className="grid grid-rows-min-con-3 mb-32 mt-14 md:mt-20"
    >
      {!user && <Link href="/users/plan">{backText}</Link>}
      <br />
      <UserRow header="Recipient Information">
        {giftSubscription.recipient.map((recipient, index) => (
          <Fragment key={index}>
            <TextField
              required
              label="* Recipient E-Mail Address"
              name="recipientEmail"
              value={recipient.recipientEmail}
              onChange={handleOnRecipientChange}
              id={index.toString()}
              onEnter={handleEnter}
            />

            <TextField
              required
              label="* Recipient First name"
              name="recipientFirstName"
              value={recipient.recipientFirstName}
              onChange={handleOnRecipientChange}
              id={index.toString()}
              onEnter={handleEnter}
            />
            <TextField
              required
              label="* Recipient Last name"
              name="recipientLastName"
              value={recipient.recipientLastName}
              onChange={handleOnRecipientChange}
              id={index.toString()}
              onEnter={handleEnter}
            />
          </Fragment>
        ))}
        <button
          className="no-underline hover:underline hover:text-blue-600 text-blue-600 cursor-pointer text-left"
          onClick={() => handleAddRecipient()}
        >
          Add Recipient
        </button>
      </UserRow>
      <UserRow header="Your Information">
        <TextField
          required
          label="* Your E-Mail Address"
          name="customerEmail"
          value={giftSubscription.customerEmail}
          onChange={handleOnChange}
          onEnter={handleEnter}
        />
        <TextField
          required
          label="* Your First name"
          name="customerFirstName"
          value={giftSubscription.customerFirstName}
          onChange={handleOnChange}
          onEnter={handleEnter}
        />
        <TextField
          required
          label="* Your Last name"
          name="customerLastName"
          value={giftSubscription.customerLastName}
          onChange={handleOnChange}
          onEnter={handleEnter}
        />
        {<TextArea
          label="Personal message to recipient"
          name="personalMessage"
          value={giftSubscription.personalMessage}
          onChange={handleOnChange}
        />}
      </UserRow>
      <UserRow header="Order Details">
        <TextArea
          label="Comments"
          name="comments"
          value={giftSubscription.comments}
          onChange={handleOnChange}
        />
      </UserRow>
      <UserRow>
        <Button
          type="Update"
          label="Go to checkout"
          className="bg-opacity-10 w-full"
          labelColor="text-black"
          onClick={submitInfo}
          disabled={isDisabled}
          isLoading={isLoading}
        ></Button>
      </UserRow>
    </div>
  );
};
